export default "__VITE_ASSET__d4aaaa30__"